import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveWeProvide,
  createWeProvide,
  deleteWeProvide,
  getAllActiveWeProvide,
  getAllWeProvide,
  getWeProvideByID,
  WeProvideDetailsImageUpload,
  updateWeProvide,
} from "./services/weProvide.services";
import { IWeProvide, IWeProvides } from "./weProvideModal";

const initialState: IWeProvides = {
  loading: false,
  formloading: false,
  error: "",
  WeProvideID: null,
  WeProvideList: [],
  WeProvideDetail: {
    ID: null,
    ServiceID: "",
    Title: "",
    Subtitle: "",
    Description: "",
    IsActive: 1,
  },
};

const weProvideSlice = createSlice({
  name: "weprovide",
  initialState,
  reducers: {
    clearWeProvideDetails: (state) => {
      state.WeProvideDetail = initialState.WeProvideDetail;
    },
    setWeProvideID: (state, action) => {
      state.WeProvideID = action.payload;
    },
    clearWeProvideID: (state) => {
      state.WeProvideID = initialState.WeProvideID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWeProvide.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWeProvide.fulfilled,
      (state, action: PayloadAction<IWeProvide[]>) => {
        state.loading = false;
        state.WeProvideList = action.payload || [];
      }
    );
    builder.addCase(getAllWeProvide.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WeProvideList = [];
    });
    builder.addCase(createWeProvide.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWeProvide.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createWeProvide.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWeProvide.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWeProvide.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWeProvide.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWeProvide.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWeProvide.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWeProvide.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWeProvideByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWeProvideByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.WeProvideDetail = action.payload;
    });
    builder.addCase(getWeProvideByID.rejected, (state, action) => {
      state.loading = false;
      state.WeProvideDetail = initialState.WeProvideDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWeProvide.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWeProvide.fulfilled,
      (state, action: PayloadAction<IWeProvide[]>) => {
        state.loading = false;
        state.WeProvideList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveWeProvide.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WeProvideList = [];
    });
    builder.addCase(ActiveInactiveWeProvide.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWeProvide.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWeProvide.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(WeProvideDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(WeProvideDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(WeProvideDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearWeProvideDetails, clearWeProvideID, setWeProvideID } =
  weProvideSlice.actions;
export default weProvideSlice.reducer;
